import type { ReactNode } from "react";

export const ImportDialogFooter = ({ children }: { children: ReactNode }) => (
  <div className="tw-absolute tw-bottom-2 tw-left-1/2 tw-flex tw-w-[calc(100%-16px)] -tw-translate-x-1/2 tw-items-center tw-justify-center tw-gap-12 tw-rounded-2xl tw-bg-white tw-py-4 tw-pl-6 tw-pr-4 tw-shadow-md tw-outline tw-outline-1 tw-outline-offset-0 tw-outline-blue/5">
    {children}
  </div>
);
